export class Coordinate {

    degrees!: number;

    minutes!: number;

    decimal!: number;

    isEnteredManually!: boolean;

    constructor() {

    }


    /**
     * 
     * @param dec Coordinate decimal form
     * @returns Coordinate object translated from dec
     */
    static fillDegrees(dec: number, manual?: boolean) {
        let coord = new Coordinate;
        coord.decimal = dec;
        coord.degrees = Math.floor(Math.abs(dec));
        coord.minutes = Number.parseFloat(((Math.abs(dec) - coord.degrees) * 60).toFixed(2));
        coord.isEnteredManually = manual ?? false;
        return coord;
    }


    /**
     * Fills this Coordinate object's decimal field based on its degrees, minutes
     */
    fillDecimal() {
        this.decimal = this.degrees + (this.minutes / 60);
    }

    isUnfilled() {
        return this.degrees == undefined && this.minutes == undefined
    }

    toString() {
        return (this.degrees !== undefined && this.minutes !== undefined) ? Math.abs(this.degrees) + "\u00B0" + " " + this.minutes + "\'" + ((this.decimal < 0) ? 'W' : 'N') : "";
    }

    static transformAnon(anon: any) {
        let coord = new Coordinate;
        if (anon) {
            coord.decimal = anon.decimal;
            coord.degrees = anon.degrees;
            coord.minutes = anon.minutes;
            coord.isEnteredManually = anon.isEnteredManually ?? false;
        }
        return coord;
    }
}